<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Configurações</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-tabs type="card" class="abas">
      <el-tab-pane label="Orcamentos">
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <h1>Configurações de Orçamentos</h1>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card class="box-card" v-loading="loading">
              <div slot="header" class="clearfix">
                <el-row justify="left">
                  <el-col :xs="24" :sm="24" :md="13" :lg="13" :xl="13">
                    <span>Lucro</span>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                    <CadastroConfigRentab
                      v-if="permissao.editar_configuracoes"
                      v-on:dadosRentab-click="onDadosRentabClick"
                    ></CadastroConfigRentab>
                  </el-col>
                </el-row>
              </div>
              <el-popover ref="popover4" placement="right" width="400" trigger="click">
                <el-table :data="itensRentabilidade" empty-text="Sem dados!">
                  <el-table-column width="50" property="id" label="Cód."></el-table-column>
                  <el-table-column width="70" property="valor" label="Valor" :formatter="formatter"></el-table-column>
                  <!--  -->
                  <el-table-column width="100" property="data" label="Data"></el-table-column>
                  <el-table-column
                    v-if="permissao.excluir_configuracoes"
                    prop="acao"
                    label="Ação"
                    filter-placement="bottom-end"
                  >
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-tooltip class="item" effect="light" content="Excluir" placement="top">
                          <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)"
                            icon="el-icon-delete"
                          ></el-button>
                        </el-tooltip>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </el-table>
              </el-popover>
              <el-row>
                <el-col :span="14">
                  <h3>Valor Atual:</h3>
                  <h3>{{valor_atual}}%</h3>
                  <p>Desde: {{data_atual}}</p>
                </el-col>
                <el-col :span="10">
                  <el-button v-popover:popover4>Histórico de Alterações</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card class="box-card" v-loading="loadingComissao">
              <div slot="header" class="clearfix">
                <el-row justify="left">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <span>Comissão</span>
                  </el-col>
                </el-row>
              </div>              
              <el-row>
                <el-col :span="24">
                    <CadastroConfigComissao
                      v-if="permissao.editar_configuracoes"
                      v-on:dadosComissao-click="onDadosComissaoClick"
                    ></CadastroConfigComissao>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top:20px;">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card class="box-card" v-loading="loading">
              <div slot="header" class="clearfix">
                <el-row justify="left">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <span>Funções para Custo de Mão de Obra</span>
                  </el-col>
                </el-row>
              </div>
              <CadastroConfigFuncao></CadastroConfigFuncao>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card class="box-card" v-loading="loading">
              <div slot="header" class="clearfix">
                <el-row justify="left">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <span>Configurações</span>
                  </el-col>
                </el-row>
              </div>
              <CadastroConfigList></CadastroConfigList>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Usuários - Grupos">
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <h1>Configurações de Grupos de Usuários</h1>
          </el-col>
        </el-row>
        <GruposUsers></GruposUsers>
      </el-tab-pane>
      <el-tab-pane label="Tabela ICMS">
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <h1>ICMS - Tabela de Alíquotas nas Operações Interestaduais</h1>
          </el-col>
        </el-row>
        <TabelaIcms></TabelaIcms>
      </el-tab-pane>
      <el-tab-pane label="Textos Proposta Comercial">
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <h1>Proposta Comercial</h1>
          </el-col>
        </el-row>
        <PropostaComercial></PropostaComercial>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import FuncoesUteis from "../../plugins/FuncoesUteis";
import CadastroConfigRentab from "@/components/configuracoes/CadastroRentab.vue";
import CadastroConfigComissao from "@/components/configuracoes/CadastroComissao.vue";
import CadastroConfigList from "@/components/configuracoes/CadastroConfigList.vue";
import CadastroConfigFuncao from "@/components/configuracoes/CadastroFuncao.vue";
import TabelaIcms from "@/components/configuracoes/TabelaIcms.vue";
import GruposUsers from "@/components/configuracoes/GruposUsers.vue";
import PropostaComercial from "@/components/configuracoes/PropostaComercial.vue";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";

export default {
  components: {
    CadastroConfigRentab,
    CadastroConfigComissao,
    CadastroConfigList,
    CadastroConfigFuncao,
    GruposUsers,
    TabelaIcms,
    PropostaComercial,
  },
  data() {
    return {
      loading: true,
      loadingComissao: true,
      rentabilidade_data: "",
      rentabilidade_valor: "",
      itensRentabilidade: [],
      valor_atual: "",
      data_atual: "",
      itensComissao: [],
      valor_atual_comissao: "",
      data_atual_comissao: "",
      list_comissao: [
        {'name':'teste',
        'slug':'teste1',
        'valor':'23'}
      ],
      permissao: {},
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.loading = true;
    axios
      .get(url + "/list_config_rentab/0/1000", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.itensRentabilidade = response.data;
          let vl = new String(this.itensRentabilidade[0].valor);
          vl = vl.replace(",", "");
          vl = vl.replace(".", ",");
          this.valor_atual = vl;

          this.data_atual = this.itensRentabilidade[0].data;
          this.loading = false;
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });
      this.loadingComissao = true;

      this.loadingComissao = false;
  },
  methods: {
    //////////////////////////////////////////////
    formatter(row) {
      let vl = new String(row.valor);
      vl = vl.replace(",", "");
      vl = vl.replace(".", ",");
      return vl;
    },
    // formatter(row,collum) {
    //   let vl = new String(row.valor);
    //   //vl = vl.replace(",", "");
    //   //vl = vl.replace(".", ",");
    // //  row.valor = vl;
    //   return //row.valor;
    // },
    ///////////////////////////////////////////////
    getDadosRentab: function () {
      axios
        .get(url + "list_config_rentab/0/1000", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.itensRentabilidade = response.data;
            let vl = new String(this.itensRentabilidade[0].valor);
            vl = vl.replace(",", "");
            vl = vl.replace(".", ",");
            this.valor_atual = vl;
            this.data_atual = this.itensRentabilidade[0].data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.total = "erro" + err;
        })
        .finally(() => {
          let vl = new String(this.itensRentabilidade[0].valor);
          vl = vl.replace(",", "");
          vl = vl.replace(".", ",");
          this.valor_atual = vl;
          this.data_atual = this.itensRentabilidade[0].data;
        });
    },
    //BUSCA DADOS RENTABILIDADE APÓS SALVAR
    onDadosRentabClick: function () {
      this.loading = true;
      this.getDadosRentab();
      this.loading = false;
    },
    //EXCLUIR DADOS RENTABILIDADE
    handleDelete(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/config_rentab/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDadosRentab();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    //FIM EXCLUIR DADOS COMISSÃO
    getDadosComissao: function () {
      axios
        .get(url + "/list_config_comissao/0/1000", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.itensComissao = response.data;

            // this.valor_atual_comissao = this.itensComissao[0].valor;
            let vl = new String(this.itensComissao[0].valor);
            vl = vl.replace(",", "");
            vl = vl.replace(".", ",");
            this.valor_atual_comissao = vl;
            this.data_atual_comissao = this.itensComissao[0].data;
            this.loadingComissao = false;
          }
        })
        .catch((err) => {
          this.total = "erro" + err;
        });
    },
    //BUSCA DADOS COMISSÃO APÓS SALVAR
    onDadosComissaoClick: function () {
      this.loading = true;
      this.getDadosComissao();
      this.loading = false;
    },

  },
};
</script>

<style>
.el-main {
  padding-bottom: 100px!important;
}
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 18px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.abas {
  margin-top: 30px;
}
</style>